import { ChangeDetectorRef, Component, Input, SimpleChanges, TemplateRef } from '@angular/core';
import { Person } from '../../models/person.model';
import { DynamicListComponent, DynamicListItemAction, DynamicListSelectionAction } from '../dynamic-list/dynamic-list.component';
import { SmsSendPopupComponent, SmsSendPopupComponentData } from 'src/app/communication/sms-send-popup/sms-send-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { PermissionsService } from '../../services/permissions.service';
import { Variable, VariableMap } from '../../types/common';
import { DropdownOption } from '../../types/forms';

interface PersonListItem extends Person {
  selected: boolean;
}

export type PersonsListComponentColumnDef = {
  key: string;
  title: string;
  template?: TemplateRef<any>;
};

export enum PersonsListComponentFilterType {
  TEXT,
  DROPDOWN,
}

export type PersonsListComponentFilter<T> = {
  key: string;
  type: PersonsListComponentFilterType;
  label: string;
  anyLabel?: string;
  options?: DropdownOption<T>[];
  value?: any;
};

export type PersonsListMoveEvent = {
  from: number;
  to: number;
};

export type PersonsListSelectionAction = {
  label: string;
  callback: (selectedPersons: PersonListItem[]) => void;
};

export enum PersonsListItemActionType {
  OPEN,
  EDIT,
  DELETE,
  MOVE,
  CALL,
  SEND_SMS,
  SEND_EMAIL,
}

export type PersonsListItemAction = {
  actionType: PersonsListItemActionType;
  person: Person;
};

@Component({
  selector: 'cm-persons-list',
  templateUrl: './persons-list.component.html',
  styleUrls: ['./persons-list.component.scss'],
})
export class PersonsListComponent<L> extends DynamicListComponent<Person, L> {
  @Input() persons: Person[];
  @Input() entity = 'person';
  @Input() startingScrollIndex = 0;
  @Input() messageVariables: VariableMap = {};
  @Input() canSwipe = true;
  @Input() canReorder = false;
  @Input() personActions: PersonsListItemActionType[] = [];

  actions: DynamicListItemAction<Person>[] = [];
  personsSelectionActions: DynamicListSelectionAction<Person>[] = [
    {
      label: 'Enviar SMS',
      callback: (items) => this.sendSms(items),
    },
  ];

  constructor(changeDetectorRef: ChangeDetectorRef, permissionsService: PermissionsService, private matDialog: MatDialog) {
    super(changeDetectorRef, permissionsService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (changes.personActions && changes.personActions.currentValue) {
      const actions: DynamicListItemAction<Person>[] = [];

      this.personActions.forEach((actionType) => {
        switch (actionType) {
          case PersonsListItemActionType.SEND_SMS:
            actions.push({
              label: 'Enviar SMS',
              callback: (item) => this.sendSms([item]),
            });
            break;
          case PersonsListItemActionType.CALL:
            actions.push({
              label: 'Ligar',
              callback: (item) => this.call(item),
            });
            break;
          default:
            break;
        }
      });

      this.actions = actions;
    }

    if (changes.selectionActions) {
      this.personsSelectionActions = [
        ...this.selectionActions,
        {
          label: 'Enviar SMS',
          callback: (items) => this.sendSms(items),
        },
      ];
    }
  }

  private sendSms(persons: Person[]) {
    this.matDialog.open(SmsSendPopupComponent, {
      height: '550px',
      width: '600px',
      data: {
        contacts: persons.map((person) => ({
          msisdn: person.msisdn,
          data: {
            [this.entity]: person,
          },
        })),
        variables: this.messageVariables,
      } as SmsSendPopupComponentData,
      panelClass: 'popup-component-pane',
    });
  }

  private call(person: Person) {
    window.open(`tel:${person.msisdn}`);
  }
}
